export interface ReceiptDetailRouteParamsInput {
  transactionId?: string;
}

export interface ReceiptDetailRouteParams {
  transactionId: string;
}

const MAX_TRANSACTION_ID_LENGTH = 255;

export function normalizeReceiptDetailParams(
  params: ReceiptDetailRouteParamsInput,
): ReceiptDetailRouteParams | null {
  const transactionId = params.transactionId?.trim();

  if (!transactionId || transactionId.length > MAX_TRANSACTION_ID_LENGTH) {
    return null;
  }

  return { transactionId };
}
